import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        preview: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'user.Preview Materials' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="iframe-wrapper02">
                <div class="inner">
                    <iframe
                        ng-src="{{ vm.previewLink }}"
                        height="{{ vm.height }}"
                        frameborder="0"
                        allowfullscreen
                        ></iframe>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        class="btn main"
                        type="button"
                        ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Ok' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $window, $sce, ModalService) {
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.previewLink = $sce.trustAsResourceUrl(this.preview.previewLink);
        this.height = $window.innerHeight * 90 / 100;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/version/training/scormPreview/index.js